// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-home-index-js" + "-" + "c2937a8ae24366a673d4" + ".js";
};